module.exports = __webpack_public_path__ + "static/img/kefu.b26b6c15.png";